import { useQuery } from "@tanstack/react-query";
import { getEffectivePermissions } from "@/api/authorization";
import { useAuth } from "@/features/auth/hooks/useAuth";
import { ministryIdForApi } from "@/api/ministryContext";
export function useEffectivePermissions(ministryId?: string | null, enabled = true) {
  const scopeId = ministryIdForApi(ministryId);
  const { churchId } = useAuth();
  const query = useQuery({
    queryKey: scopeId ? ["effective-permissions", churchId, scopeId] : ["effective-permissions", churchId],
    queryFn: () => getEffectivePermissions(churchId!, scopeId),
    enabled: !!churchId && enabled,
  });
  return { ...query, permissions: new Set(query.data?.permissions ?? []) };
}
